import axios from './request'
/**
 * 获取他人获奖数据
 * @param {String} promotionCode 抽奖code
 */
export function fetchOtherPrizeList(promotionCode) {
  return axios.post('/feapi/activity/h5/promotion/draw/getotherprizelist', {
    promotionCode: promotionCode
  })
}

/**
 * 获取我的奖品
 * @param {String} promotionCode 抽奖code
 */
export function fetchMyPrize(promotionCode) {
  // return axios.post('/feapi/activity/h5/promotion/draw/myprize', {
  return axios.post('/feapi/activity/h5/promotion/draw/mygroupprize', {
    promotionCode: promotionCode
  })
}

/**
 * 提交邮寄信息
 * @param {String} address 邮寄地址
 * @param {String} lotteryRecordCode 抽奖id
 * @param {String} mobile 手机号
 * @param {String} userId 用户id
 * @param {String} userName 用户姓名
 * @param {String} zipCode 邮编
 */
export function submitMailAddress(addressInfo) {
  return axios.post('/feapi/activity/h5/promotion/draw/savemailaddress', addressInfo)
}

/**
 * 抽奖页面配置
 * @param {String} promotionCode 抽奖code
 */
export function fetchShowDrawPage(promotionCode) {
  return axios.post('/feapi/activity/h5/promotion/draw/showdrawpage', {
    promotionCode: promotionCode
  })
}

/**
 * 开始抽奖
 * @param {String} promotionCode 抽奖code
 */
export function doStartDraw(promotionCode) {
  return axios.post('/feapi/activity/h5/promotion/draw/startdraw', {
    promotionCode: promotionCode
  })
}
